import { render, staticRenderFns } from "./WhiteCardActiveRecordModal.vue?vue&type=template&id=5a491126"
import script from "./WhiteCardActiveRecordModal.vue?vue&type=script&lang=js"
export * from "./WhiteCardActiveRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports